export default __webpack_public_path__ + "static/media/rating-empty-box.9bbe3788.svg";